import { DocumentEntry } from '../../../interfaces';
import { RFXQuestion, RFXQuestionDocumentEntry } from '../../../interfaces/RFXQuestionModel';
import { convertDocuments } from '../common/frontendConverter';

export const DELETED_MESSAGE: string = 'This message has been deleted.';
const FILEUPLOAD_FAILURE_DELETED_MESSAGE: string = 'File uploading failed. This message has been deleted.';

/** Convert RFXQuestion entity into documentEntries
 *  which contain document info like URL and file size
 *
 * @param {RFXQuestion}  rfxQuestion - RFX Question Entity.
 * @returns {RFXQuestionDocumentEntry[]} return list of documentEntry
 */
export function convertRFXQuestionToDocumentEntries(rfxQuestion: RFXQuestion): RFXQuestionDocumentEntry[] {
  if (rfxQuestion.rfxQuestionDocuments.length === 0) {
    return [];
  }
  const documentEntries: DocumentEntry[] = convertDocuments(rfxQuestion.rfxQuestionDocuments).documentEntries;
  return documentEntries.map((documentEntry) => {
    return {
      ...documentEntry,
      rfxQuestionRevisionedId: rfxQuestion.rfxQuestionRevisionedId,
      rfxRequestRevisionedId: rfxQuestion.rfxRequestRevisionedId,
      size: '0',
      author: rfxQuestion.author
    };
  });
}

/** Construct the payload for putRFXQuestion
 *  to delete the RFXQuestion.
 *
 * @param {rfxQuestion | undefined}  rfxQuestion - RFX Question Entity.
 * @returns {RFXQuestion} return the RFXQuestion payload to be deleted
 */
export function constructMessageDeletePayload(rfxQuestion: RFXQuestion | undefined): RFXQuestion {
  return {
    rfxQuestionRevisionedId: rfxQuestion?.rfxQuestionRevisionedId!,
    rfxQuestionVersion: rfxQuestion?.rfxQuestionVersion!,
    rfxRequestRevisionedId: rfxQuestion?.rfxRequestRevisionedId!,
    author: rfxQuestion?.author!,
    rfxQuestionClassId: {
      value: 'AWSRFQQuestion'
    },
    message: DELETED_MESSAGE,
    contentType: 'text/plain',
    createdAt: rfxQuestion?.createdAt!,
    lastUpdatedAt: Date.now(),
    rfxQuestionDocuments: rfxQuestion?.rfxQuestionDocuments!,
    properties: rfxQuestion?.properties
  };
}

/** Construct the payload for putRFXQuestion
 *  to indicate the file-uploading failure.
 *
 * @param {rfxQuestion | undefined}  rfxQuestion - RFX Question Entity.
 * @returns {RFXQuestion} return the RFXQuestion payload to be deleted
 */
export function constructMessageFailUploadPayload(rfxQuestion: RFXQuestion | undefined): RFXQuestion {
  return {
    rfxQuestionRevisionedId: rfxQuestion?.rfxQuestionRevisionedId!,
    rfxQuestionVersion: rfxQuestion?.rfxQuestionVersion!,
    rfxRequestRevisionedId: rfxQuestion?.rfxRequestRevisionedId!,
    author: rfxQuestion?.author!,
    rfxQuestionClassId: {
      value: 'AWSRFQQuestion'
    },
    message: FILEUPLOAD_FAILURE_DELETED_MESSAGE,
    contentType: 'text/plain',
    createdAt: rfxQuestion?.createdAt!,
    lastUpdatedAt: Date.now(),
    rfxQuestionDocuments: rfxQuestion?.rfxQuestionDocuments!,
    properties: rfxQuestion?.properties
  };
}
